export default "__VITE_ASSET__qIUGsMtW__"